import { render, staticRenderFns } from "./PreModule.vue?vue&type=template&id=46ff7006&"
import script from "./PreModule.vue?vue&type=script&lang=ts&"
export * from "./PreModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports